import { type ForwardedRef, forwardRef } from 'react';

import * as api from '@gitbook/api-client';
import { getSiteProductDefinition } from '@gitbook/app-pricing';
import { Badge, type BadgeProps } from '@gitbook/spine-react';

interface SiteTypeBadgeProps extends Omit<BadgeProps, 'label'> {
    type: api.SiteType;
}

export const SiteTypeBadge = forwardRef(function SiteTypeBadge(
    props: SiteTypeBadgeProps,
    ref: ForwardedRef<HTMLDivElement>
) {
    const { type, ...rest } = props;
    const definition = getSiteProductDefinition(type);
    return (
        <Badge
            ref={ref}
            label={definition.title}
            kind={
                type === api.SiteType.Ultimate
                    ? 'ultimate'
                    : type === api.SiteType.Premium
                      ? 'info'
                      : 'secondary'
            }
            size="small"
            {...rest}
        />
    );
});
